import { useMuseCategories } from "@/constants/areas";
import classNames from "classnames";
import { useMemo } from "react";
import Image from "../Image";
import styles from "./index.module.less";

export function MuseTag({
  className = "",
  textClassName = "",
  withText = false,
  user,
  size = 16,
  title = "",
  customIcon = null,
}) {
  const { data } = useMuseCategories();
  const code = user?.museUser?.category[0];

  const isCertifyCompany = code === "company";

  const museName = useMemo(() => {
    return data.find((category) => category.code === code)?.name;
  }, [code, data]);

  return (
    <>
      <div
        className={classNames(
          className,
          styles.icon,
          isCertifyCompany ? styles.company : styles.personal
        )}
        style={{
          fontSize: size,
        }}
        title={title || `认证${museName || "设计师"}`}
      >
        {customIcon || (
          <Image
            src="https://grocery-cdn.huaban.com/file/1e1aefc04a7b11f0aadd17477f0bb4b9.svg"
            alt="muse"
            width={size || 20}
            height={size || 20}
          />
        )}
      </div>
      {withText && (
        <span
          className={classNames(textClassName, styles.text)}
          style={{ lineHeight: size + "px" }}
        >
          {isCertifyCompany
            ? `认证企业：${user?.museUser?.name}`
            : `${museName}`}
        </span>
      )}
    </>
  );
}
